// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgMinusIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path fillRule="evenodd" d="M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1" />
  </g>
);
export default SvgMinusIcon;
SvgMinusIcon.displayName = 'SvgMinusIcon';
